var jQuery = require('jquery');
window.jQuery = jQuery;
window.$ = jQuery;

require('moment');
require('bootstrap/js/dist/alert');
require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');
// require('bootstrap/js/dist/util');

require('bootstrap-select');
// require('bootstrap-datepicker');



require('jquery.placeholder');
require('jquery-sticky');
// require('jquery-match-height');

require('owl.carousel');
require('magnific-popup');
// require('lazysizes');
// require('picturefill');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
$(function() {

    // Initialise the Ajax funxctions - put most of your js calls in this function
    // or if you need to reload them after an ajax call
    // initAjaxJS();

    // $(window).load(function() {
    // });

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

        // track all slideshow events
        $('a.slideshow-link').on('click', function (e) {

            var title = $(this).data('title');
        //    alert(title);
            ga('send', 'event', 'Slideshow', 'Clicked banner', title);


        });



    }

    $('.selectpicker').selectpicker();

    $('#login-modal').on('shown.bs.modal', function() {
        $('#email').trigger('focus')
    })

    // placeholder polyfill for browsers that need it
    $('input, textarea').placeholder();

    // Off canvas mobile nav
    $('[data-toggle="offcanvas"]').click(function() {
        $('.offcanvas').toggleClass('active');
        $(this).toggleClass('close-btn')

    });

    $("#mob-links.mob-header-links").sticky({ topSpacing: 0 });
    $("#main-nav.navbar").sticky({ topSpacing: 0 });

    if ($(window).width() > 991) {
        // $(".gmap").sticky({ topSpacing: 60 });
        // $(".gmap").unstick({   bottomSpacing:725 });


        var footerBottomAdjust = $('#footer').height() + 50;
        $('.gmap').sticky({
            topSpacing: 70,
            bottomSpacing: footerBottomAdjust
        });

    }

    // $('.gmap').on('sticky-update', function() { console.log("Update"); });

    if ($('#home-slider').length) {
        $('#home-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dot: true,
            autoplay: true,
            autoplayTimeout: 8000,
            smartSpeed: 750,
            animateIn: 'fadeIn', // add this
            animateOut: 'fadeOut'
        })
    }

    if ($('#instagram-feed').length) {
        $('#instagram-feed').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 16,
            responsiveClass: true,
            items: 2,
            nav: false,
            dot: true,
            autoplay: true,
            autoplayTimeout: 6000,
            smartSpeed: 750,
            responsive: {
                576: {
                    items: 3,
                },
                768: {
                    items: 4,
                },
                992: {
                    items: 4,
                    margin: 32
                }
            }
        })
    }

    $('.scrollup').click(function() {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });

    $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
        $('#page-top').fadeIn();
    } else {
        $('#page-top').fadeOut();
    }
});

    $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        gallery: {
            enabled: true
        },
    });

    // Mask emails from spammers
    // $('.mask-email').each(function() {
    //     var $email = $(this);
    //     var css = $email.attr('class');
    //     // var label = $email.attr('title');
    //     var address = $email.text().replace(/\s*\[at\]\s*/, '@').replace(/\s*\[dot\]\s*/g, '.');
    //     var query = $email.data('query'); // get query string parameters if present
    //     var params = "";
    //     if (query != null) {
    //         params = query;
    //     }
    //     $email.html('<a href="mailto:' + address + params + '" class="' + css + '">' + address + '</a>');
    //     // clear em out
    //     $email.attr('class', '');
    //     $email.attr('data-query', '');
    // });


    //tabbed url
    // if (location.hash.substr(0, 2) == "#!") {
    //     $("a[href='#" + location.hash.substr(2) + "']").tab("show");
    // }

    // $("a[data-toggle='tab']").on("shown.bs.tab", function(e) {
    //     var hash = $(e.target).attr("href");
    //     if (hash.substr(0, 1) == "#") {
    //         location.replace("#!" + hash.substr(1));
    //     }
    // });

    $('.ql-video').each(function(idx, el) {
        const embedContainer = $('<div/>', {
            class: 'embed-responsive embed-responsive-16by9',
        });
        $(el).wrap(embedContainer);
    });
})


//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {


}